import pageheader from "../pageheader";
import utils from "../../utils/util";
import { mapGetters } from "vuex";
import smsService from "../../api/reservePlanNew.service";
import constants from "../../config/constants";
import rules from "../../utils/rules";

export default {
  name: "planning-sheet-exceptions",
  components: { pageheader },
  data() {
    return {
      errorMSG: "",
      rules: rules,
      planningSheetValid: true,
      isCreatingPlanningSheet: false,
      planningSheetDialog: false,
      planSearchFilter: "",
      selectedPlan: {},
      reportsListDropDown: [],
      isReportLoadingDropDown: false,
      itemId: "",
      headers: [
        {
          text: "SNO",
          align: "center",
          sortable: false,
          value: "sno",
        },
        { text: "", value: "image", width: "5px", fixed: true },
        { text: "Name", value: "projectionName" },
        { text: "Jobsite", value: "jobsite" },

        { text: "Action", value: "action" },
      ],
      newProjectionName: "",
      search: "",
      dialog: false,
      planningSheets: [],
      options: {},
      loading: false,

      input: {},
      deleteId: null,
      delName: "",
      isdelete: false,
    };
  },
  computed: {
    ...mapGetters(["roles"]),
  },
  mounted() {
    this.input = utils.getInputContent("planningSheetMapping", this.roles);
    if (
      this.$store.getters.companyIdDropdown == null ||
      this.$store.getters.companyIdDropdown == "" ||
      this.$store.getters.companyIdDropdown == undefined
    ) {
      this.errorMSG = constants.ERROR_COMPANY_NOT_SELECTED;
    } else {
      this.errorMSG = "";
      this.readDataFromAPI();
    }
  },
  methods: {
    openPlanningSheetDialog() {
      this.planningSheetDialog = true;
      this.getReportListDropdown();
    },
    editPlanningSheet(item) {
      this.getReportListDropdown();
      this.selectedPlan = {
        projectionName: item.projectionName,
        projectionID: item.projectionId,
      };
      this.newProjectionName = item.jobsite;
      this.itemId = item.id;
      this.planningSheetDialog = true;
    },

    closePlanningSheetDialog() {
      this.$refs.form.reset();
      this.planningSheetDialog = false;
      this.itemId = "";
      this.selectedPlan = {};
    },
    async readDataFromAPI() {
      this.loading = true;
      try {
        let planningSheetsListRes;

        planningSheetsListRes =
          await smsService.getAllPlanningSheetExceptions();

        if (planningSheetsListRes) {
          this.loading = false;
          this.planningSheets = planningSheetsListRes.data.map((d, index) => ({
            ...d,
            sno: index + 1,
          }));
        }
      } catch (err) {
        this.$toast.error("Unable to load the planningSheets" + err);
        this.loading = false;
      }
    },
    async getReportListDropdown() {
      this.isReportLoadingDropDown = true;

      try {
        let response = await smsService.getPlannedVsActualReportDropdown();
        if (response.data && response.isSuccess) {
          this.reportsListDropDown = response.data;

          this.isReportLoadingDropDown = false;
        } else {
          this.reportsListDropDown = [];
          this.isReportLoadingDropDown = false;
        }
      } catch (err) {
        console.log(err);
      }
    },
    confirmDelete(item) {
      this.deleteId = item.projectionId;
      this.delName = item.jobsite;
      this.dialog = true;
    },
    async deletePlanningSheet() {
      try {
        this.isdelete = true;

        let delUser = await smsService.removePlanningSheetExceptionsById(
          this.deleteId
        );
        if (delUser) {
          this.isdelete = false;
          this.$toast.success(delUser.systemMessage);
          this.readDataFromAPI();
          this.dialog = false;
        }
      } catch (err) {
        this.isdelete = false;
        this.$toast.error("Unable to delete user" + err);
        this.dialog = false;
      }
    },
    async createPlanningSheets() {
      if (this.$refs.form.validate()) {
        this.isCreatingPlanningSheet = true;
        let payload = {
          projectionId: this.selectedPlan.projectionID,
          projectionName: this.selectedPlan.projectionName,
          jobsite: this.newProjectionName,
        };

        try {
          var apiResponse = await smsService.createPlanningSheetExceptionsById(
            this.selectedPlan.projectionID,
            payload
          );

          if (apiResponse) {
            this.isCreatingPlanningSheet = false;
            this.$refs.form.reset();
            this.$toast.success(apiResponse.systemMessage);
            this.readDataFromAPI();
            this.planningSheetDialog = false;
          }
        } catch (err) {
          this.isCreatingPlanningSheet = false;
          this.$toast.error("Unable to create planning sheet exception" + err);
        }
      }
    },
    async updatePlanningSheets() {
      if (this.$refs.form.validate()) {
        this.isCreatingPlanningSheet = true;
        let payload = {
          id: this.itemId,
          projectionId: this.selectedPlan.projectionID,
          projectionName: this.selectedPlan.projectionName,
          jobsite: this.newProjectionName,
        };

        try {
          var apiResponse = await smsService.updatePlanningSheetExceptionsById(
            this.selectedPlan.projectionID,
            payload
          );

          if (apiResponse) {
            this.isCreatingPlanningSheet = false;
            this.$refs.form.reset();
            this.$toast.success(apiResponse.systemMessage);
            this.readDataFromAPI();
            this.planningSheetDialog = false;
            this.itemId = "";
          }
        } catch (err) {
          this.isCreatingPlanningSheet = false;
          this.$toast.error("Unable to update planning sheet exception" + err);
        }
      }
    },
    clearSearch() {
      this.search = "";
      this.$router.replace(`/point-of-planningSheets/list`);
      this.readDataFromAPI();
    },
  },
};
